import { Pagination } from '@/domain/models'
import { ContentReviewsModel } from '@/domain/models/content/review/content-reviews-model'

export interface ContentReviews {
  get(params: ContentReviews.Params): Promise<ContentReviews.Model>
}

export namespace ContentReviews {
  export const DEFAULT_PAGE_SIZE = 10
  export const Key = 'content-reviews'
  export type Model = ContentReviewsModel
  export interface Params extends Pagination.Params {
    id: number
  }
}
